import { ButtonLink, theme } from '@febos-io/design';

import { useTranslation } from '../hooks';

export function Error401Page() {
  const { t } = useTranslation();
  return (
    <theme.views.Error>
      <div className="w-100 text-center">
        <h2 className="mb-1">
          {t('Page Not Found')}
          {' '}
          🕵🏻‍♀️
        </h2>
        <ButtonLink
          href="/"
          className="btn-sm-block mb-2"
        >
          {t('Back to home')}
        </ButtonLink>
      </div>
    </theme.views.Error>
  );
}

export default Error401Page;
